import React from "react";
import "./spinner.css";

export default function LoadingSpinner() {
  return (
    <div className="lds-roller"><div></div><div></div><div></div><div></div><div></div><div></div></div>
  );
}